interface SearchIconProps {
  onClick?: () => void;
}
const SearchIcon = (props: SearchIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33333 3.125C5.45685 3.125 3.125 5.45685 3.125 8.33333C3.125 11.2098 5.45685 13.5417 8.33333 13.5417C11.2098 13.5417 13.5417 11.2098 13.5417 8.33333C13.5417 5.45685 11.2098 3.125 8.33333 3.125ZM1.875 8.33333C1.875 4.76649 4.76649 1.875 8.33333 1.875C11.9002 1.875 14.7917 4.76649 14.7917 8.33333C14.7917 9.89166 14.2398 11.3211 13.3207 12.4368L17.9419 17.0581C18.186 17.3021 18.186 17.6979 17.9419 17.9419C17.6979 18.186 17.3021 18.186 17.0581 17.9419L12.4369 13.3207C11.3211 14.2397 9.8917 14.7917 8.33333 14.7917C4.76649 14.7917 1.875 11.9002 1.875 8.33333Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export default SearchIcon;
